export const reportingOrCertificationOptions = [
    'Não se aplica',
    'ISO 14001',
    'OHSAS 18000',
    'Indicadores Ethos',
    'ISE - Bovespa',
    'Relatório no formato Global Reporting Initiative',
    'Outros'
]

export const insurancePoliciesOptions = [
    'Possui apólice de seguro que cobre responsabilização por impacto socioambiental',
    'Não desenvolve atividades de impacto socioambiental',
    'Desenvolve atividades de impacto ambiental, mas não possui seguro socioambiental'
]

export const projectSpaceOptions = [
    'Zona Urbana',
    'Distrito Industrial',
    'Zona Rural',
    'Interior ou entorno de Unidade de Proteção Integral',
    'Interior de Unidade de Uso Sustentavel',
    'Área reconhecida como Patrimônio Histórico ou Cultural, Sitio Arqueológico ou Espeleológico',
    'Interior de Áreas de Preservação Permanente'
]

export const projectActivitiesOptions = [
    'Armas e munições',
    'Atividades madeireiras comerciais ou compra de equipamento madeireiro para uso em florestas tropicais úmidas primárias',
    'Bebidas alcoólicas',
    'Comércio transfronteiriço de resíduos ou derivados, exceto resíduos não perigosos destinados a reciclagem',
    'Compostos de bifenil policlorinado (PCBs)',
    'Deslocação econômica ou perda de sustento da população afetada',
    'Fauna e flora selvagens ou produtos derivados regulados pela Convenção sobre o Comércio Internacional das Espécies da Fauna e da Flora Selvagens Ameaçadas de Extinção (CITES)',
    'Fibras de asbestos soltas',
    'Jogos, cassinos e empreendimentos equivalentes',
    'Materiais radioativos',
    'Não cumprimento dos princípios e direitos fundamentais dos trabalhadores',
    'Pesca com redes de deriva no ambiente marinho usando redes com mais de 2,5 km de comprimento',
    'Pesticidas e herbicidas sujeitos à eliminação gradual ou proibição no âmbito internacional',
    'Poluentes orgânicos persistentes (POPs)',
    'Produtos farmacêuticos sujeitos à eliminação gradual ou proibição no âmbito internacional',
    'Produtos ou operações florestais sem gestão sustentável, ou projetos florestais em áreas de alto valor ecológico, com exceção de atividades que envolvam a preservação e uso sustentável e não extrativista de recursos florestais',
    'Projetos agrícolas que exijam a remoção de floresta natural não degradada',
    'Projetos com impacto negativo relevante direto ou indireto a grupos indígenas',
    'Projetos com impacto relevante direto ou indireto em áreas protegidas e outros habitats naturais',
    'Projetos com impacto relevante direto ou indireto em sítios sensíveis de relevância crítica histórica, cultural ou arqueológica',
    'Projetos com impactos transfronteiriços',
    'Projetos localizados em ou a 10km de distância de áreas protegidas e outros habitats naturais críticos',
    'Projetos localizados em ou a 10km de sítios sensíveis de relevância histórica, cultural ou arqueológica',
    'Projetos que introduzam espécies invasoras',
    'Projetos realizados em terras indígenas',
    'Reassentamento involuntário',
    'Substâncias que afetam a camada de ozônio sujeitas à eliminação gradual no âmbito internacional',
    'Tabaco',
    'Nenhuma das listadas'
]

export const requiresLicensingOptions = [
    'Não',
    'Não e a executora possui declaração de desnecessidade emitida pelo órgão ambiental',
    'Não, sendo aplicável(is) a(s) licença(s) já existente(s) para as atividades rotineiramente desenvolvidas pela executora',
    'Sim'
]

export const hasAllAuthorizationsOptions = [
    'Não há exigência de autorizações, estudos e licenças ambientais para a execução do projeto',
    'Possui as autorizações, estudos e licenças ambientais para pelo menos as etapas iniciais do projeto',
    'Não possui as autorizações, estudos e licenças ambientais necessárias para a execução do projeto'
]